import React, { FC, HTMLAttributes } from 'react';

import * as Styles from './_tabPageContainer.module.scss';

const TabPageContainer: FC<HTMLAttributes<HTMLDivElement>> = ({
    children,
}) => {
    return (
        <div className={Styles.container}>
            {children}
        </div>
    );
};

export default TabPageContainer;
